import {createApp} from 'vue'
import App from './App.vue'
import PrimeVue from 'primevue/config'
import router from './router'
import store from '@//store'
import axios from "axios"
import {createI18n} from 'vue-i18n'
import {messages, defaultLocale} from "@/i18n"

// css primevue theme, css core configuration and icons
import 'primevue/resources/themes/md-light-indigo/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import Tooltip from 'primevue/tooltip';
import ConfirmationService from 'primevue/confirmationservice';

import "./styles/index.css";


export const i18n = createI18n({
    messages,
    locale: defaultLocale,
    fallbackLocale: defaultLocale
});


const app = createApp(App)
app.use(PrimeVue) // add PrimeVue namespace to application
app.use(i18n)
app.use(router)
app.use(store)
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);
axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token;

app.mount('#app')
